/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Whitelabel } from './Whitelabel';
export type AsafBoxUserCreate = {
  name?: string;
  username: string;
  password: string;
  role?: AsafBoxUserCreate.role;
  arboxUserId?: string;
  disabled?: boolean;
  priority?: number;
  whitelabels?: Array<Whitelabel>;
};
export namespace AsafBoxUserCreate {
  export enum role {
    ADMIN = 'ADMIN',
    USER = 'USER',
  }
}

